// Pick a saved text template, or write one-off text. Reports { templateId, body }: a template sends
// template_id (the server merges the coach's name), custom text sends body.
import React from 'react';

export const SCOPE_LABELS = { personal: 'Personal', prozpects: 'ProZpects', partner: 'Team' };
export const CUSTOM = 'custom';

export default function TemplatePicker({ templates, templateId, body, onChange }) {
  const chosen = templates.find((t) => t.id === templateId);
  return (
    <div className="cr-form">
      <label className="adm-field cr-form__wide">
        <span className="adm-field__label">Message</span>
        <select className="adm-select" value={templateId == null ? CUSTOM : templateId} data-testid="template_select"
          onChange={(e) => onChange(e.target.value === CUSTOM ? { templateId: null, body } : { templateId: Number(e.target.value), body })}>
          {templates.map((t) => <option key={t.id} value={t.id}>{t.name} ({SCOPE_LABELS[t.scope] || t.scope})</option>)}
          <option value={CUSTOM}>Write my own</option>
        </select>
      </label>
      {chosen ? (
        <p className="cr-notes cr-form__wide" data-testid="template_preview">{chosen.body}</p>
      ) : (
        <label className="adm-field cr-form__wide">
          <span className="adm-field__label">Text</span>
          <textarea className="adm-input cr-textarea" value={body} data-testid="template_custom_body"
            onChange={(e) => onChange({ templateId: null, body: e.target.value })} />
        </label>
      )}
      <p className="cr-muted cr-form__wide">
        Merge fields: {'{first_name}'} {'{last_name}'} {'{school}'} {'{sender_first_name}'}. A missing first name becomes &ldquo;Coach&rdquo;.
      </p>
    </div>
  );
}
